export const DAT_INSTANCE_NAME_MAX_LENGTH = 30;
export const DAT_INSTANCE_NAME_FORBIDEN_REGEXP = '^[a-zA-ZÀ-ȕ0-9_-]+(\\s*[a-zA-ZÀ-ȕ0-9_-]*)*$';
export const DAT_INSTANCE_EID_REGEXP = '^[0-9]+$';
export const DAT_INSTANCE_CONTEXTMARK_REGEXP = '\\b([0-9]|1[0-5]|255)\\b';
